import { Auth0Client } from "@auth0/auth0-spa-js"
import { EnvironmentService } from "./EnvironmentService"

interface Auth {
  getToken: () => Promise<string>
}

const auth0Client = new Auth0Client({
  domain: EnvironmentService.getAuth0Domain() ?? "",
  client_id: EnvironmentService.getAuth0ClientId() ?? "",
  redirectUri: EnvironmentService.getAuth0LoginRedirect() ?? "",
  audience: EnvironmentService.getAuth0Audience() ?? "",
  realm: EnvironmentService.getAuth0Realm() ?? "",
  cacheLocation: "localstorage",
  useRefreshTokens: true,
})

const getToken = async () => {
  const isStorybook = process.env.STORYBOOK
  if (isStorybook) {
    return "fake_token"
  }
  return await auth0Client.getTokenSilently()
}

export const AuthService: Auth = {
  getToken,
}
